import React from "react";
import "./page.scss";

function Filtro({ children }) {
  return <div className={"page-filtro"}>{children}</div>;
}

export default Filtro;
